import React, { Component } from 'react';
import { format_bytes } from '../../utils/data';
import DataTable from '../DataTable/DataTable';
import LoadingData from '../LoadingData/LoadingData';
import SearchInput from '../SearchInput/SearchInput';
import StatusBar from '../StatusBar/StatusBar';

import './StatusTable.css';

interface Props {
    data: Array<any>
}
interface State {
    search: string
}


export default class StatusTable extends Component<Props, State>{
    state = {
        search: ''
    }
    render() {
        return (
            <div className="status-table">
                <LoadingData
                    loading={false} no_data={!this.props.data}
                    no_data_message="No Data to show"
                >

                    {
                        this.props.data &&
                        <DataTable
                            show_all
                            data={this.props.data}
                            fixed_width={{
                                'status': "350px",
                            }}
                            headers={[
                                {
                                    label: "Mission",
                                    key: 'mission'
                                },
                                {
                                    label: "Instrument",
                                    key: 'instrument'
                                },
                                {
                                    label: "Product Type",
                                    key: 'product_type'
                                },
                                {
                                    label: "Dataset",
                                    key: 'dataset'
                                },
                                {
                                    label: "Status",
                                    key: 'status'
                                },
                                {
                                    label: "N° Products",
                                    key: 'nb_prod'
                                },
                                {
                                    label: "N° Files",
                                    key: 'nb_file'
                                },
                                {
                                    label: "Size",
                                    key: 'size'
                                },
                            ]}
                            field_output={{
                                'size': (row) => format_bytes( parseFloat(row.size) * Math.pow(1000, 3), { base: 1000 }),
                                'status': (row) => 
                                    <StatusBar
                                        disk={row.disk}
                                        tape={row.tape}
                                        sent={row.sent}
                                        archived={row.archived}
                                    />
                            }}
                            // operations={isAdmin() ? this.get_operations : undefined}
                            sort_columns={{
                                'mission': { filter: 'alphabetical' },
                                'instrument': { filter: 'alphabetical' },
                                'product_type': { filter: 'alphabetical' },
                                'dataset': { filter: 'alphabetical' },
                                'nb_prod': { filter: 'numerical' },
                                'nb_file': { filter: 'numerical' },
                                'size': { filter: 'numerical' },
                            }}

                            body_max_height={500}
                        />
                    }
                </LoadingData>
            </div>
        );
    }

    get_data = () => {
        return this.state.search ?
            this.props.data.filter((d: any) =>
                d.mission.toLowerCase().includes(this.state.search) ||
                d.instrument.toLowerCase().includes(this.state.search) ||
                d.product_type.toLowerCase().includes(this.state.search) ||
                d.dataset.toLowerCase().includes(this.state.search)
            )
            :
            this.props.data
    }



};